<banner-confirmed-flight-afected
    *ngIf="hasConfirmedIrops"
></banner-confirmed-flight-afected>
<div class="am-footer animate__animated animate__fadeInUp {{ theme }}"
    [ngClass]="{
        'AmFooter-adapterLuggage': weightBag,
        'justify-content-end': flow === flowType.PRINT_TAG && !showBack,
        'AmFooter-adapterCart': showTotal,
        'AmFooter-onlyBack': showTotal && !showContinue,
        'AmFooter-threeButton': showBack && showContinue && showOptionalButton,
        'AmFooter-borderTop': borderTop,
        'AmFooter-onlyContinue': !showBack
    }">
    <button class="am-button am-button-ligth" (click)="onBack()" [disabled]="isDisbaleBack" *ngIf="showBack"
        [ngClass]="{
            'am-button-ligth': !themeDark && !mybClosed,
            'am-button-dark': themeDark && !mybClosed,
             'am-button-pink': mybClosed,
            'AmFooter-changeSizeWeight': weightBag,
            'AmFooter-changeSizeTotal': showTotal,
            'AmFooter-fullSize': backFullSize,
            'DisbaleContinue': isDisbaleBack
        }">
        {{ textOnBack | translate | capitalize }}
    </button>
    <div class="AmFooter-stepBags" *ngIf="weightBag">
        <span class="fs-24px">
            <span [innerHTML]="'printBagTag.description' | translate:{ countBag: currentNumberWeightBag, totalBags: totalWeigthBag }"></span>
        </span>
    </div>
    <button class="am-button am-button-ligth" (click)="onOptional()" *ngIf="showOptionalButton"
        [ngClass]="{
            'am-button-ligth': !themeDark,
            'am-button-dark': themeDark,
            'AmFooter-changeSizeWeight': weightBag,
            'AmFooter-changeSizeTotal': showTotal
        }">
        {{ textOptionalButton | translate | capitalize }}
    </button>
    <button class="am-button {{backGroundColorButton}}" (click)="onContinue()" [disabled]="isDisableContinue" *ngIf="showContinue"
        [ngClass]="{
            'AmFooter-changeSizeWeight': weightBag,
            'AmFooter-changeSizeTotal': showTotal,
            'AmFooter-positionRight': flow === flowType.PRINT_TAG && !showBack,
            'AmFooter-fullSize': continueFullSize,
            'loading': showLoading,
            'DisbaleContinue': isDisableContinue
        }">
        {{ textContinue | translate | capitalize }}
        <app-am-loading [typeLoading]="'FOOTER_LOADING'" *ngIf="showLoading" [blockScreen]="blockLoadingScreen"></app-am-loading>
    </button>
    <button class="am-button-finish am-button-red" (click)="onFinish()" *ngIf="showFinish"
        [ngClass]="{
            'AmFooter-changeSizeWeight': weightBag,
            'AmFooter-changeSizeTotal': showTotal,

            'AmFooter-positionRight': flow === flowType.PRINT_TAG && !showBack
        }">
        {{ textFinish | translate | capitalize }}
    </button>
    <button class="am-button am-button-red" (click)="onAddToCar()" *ngIf="showAddToCar"
    [ngClass]="{
      'am-button-pink': themePink
        }">>
      {{ 'Add TO CAR' | capitalize }}
    </button>
    <div class="am-price" *ngIf="showTotal">
        <div class="AmFooter-textTotal">
                <span class="fs-52px fw-regular lh-45px">{{ totalFooter | amCurrency:'':'symbol':'0.0' }}</span>
            <div class="AmFooter-alignBottom">
                <span class="fs-18px fw-regular lh-14px">{{ 'Total' | translate }}</span>
                <span class="fs-18px fw-regular lh-18px">{{ currencyCode }}</span>
            </div>
        </div>
    </div>
</div>

